module.exports = __webpack_public_path__ + "assets/img/4@3x.997384ce.png";